import baseAPI from "./base-api-service"
import sharedConfig from "../shared-config";

export default {
    getStaticData() {
        return baseAPI
            .getData(sharedConfig.api.staticDataEndpoint);
    },
}